@Component(
    'ib-header-main-page-component-module',
    'ibHeaderMainPage',
    {
        controllerAs: 'ibHeaderMainCtrl',
        templateUrl: [
            '$rootScope',
            ($rootScope: CommonsRootScope): string => {
                return `${$rootScope.routes.templates}ib-header-main-page-component.html`;
            }
        ]
    },
    ['ibHeaderMainPageServiceModel', 'localStorageService', '$window', '$rootScope', 'CommonsModalService', '$scope', 'CommonsUserUtilsService', 'ibHeaderMainPageConstants'],
    []
)
class ibHeaderMainPageController implements ng.IController {
    private model: ibHeaderMainPage.MainInfo;
    private updateLoginModelEvent;
    private isIbZero: boolean;
    private isSoftUser: boolean;
    private isFlowCki: boolean;
    constructor (
        private ibHeaderMainPageServiceModel: ibHeaderMainPageServiceModel,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $window: ng.IWindowService,
        private $rootScope: CommonsRootScope,
        private CommonsModalService: CommonsModalService,
        private $scope: angular.IScope,
        private CommonsUserUtilsService: CommonsUserUtilsService,
        private ibHeaderMainPageConstants: ibHeaderMainPageNameSpace.ibHeaderMainPageConstants
    ) {}
    updateLoginModel = () => {
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
        this.model = this.ibHeaderMainPageServiceModel.initializeMainPageHeader();
        this.model.login = {
            onLogin: this.onLogin,
            onError: this.onError
        };
    };
    changeLanguage = () => {
        let controlledURLPath: string = '';
        const urlParams: any = this.localStorageService.get('urlParams');
        const exclude = ['language'];

        if(this.isFlowCki) exclude.push('market');
        for (const key in urlParams) {
            if (urlParams[key] !== null && !exclude.includes(key)) {
                switch (key) {
                        case 'travelAgencies':
                            controlledURLPath += '&ckiParaAAVV=' + urlParams[key];
                            break;
                        case 'reInvoicing':
                            controlledURLPath += '&undoCKI=' + urlParams[key];
                            break;
                        default:
                            controlledURLPath += '&' + key + '=' + urlParams[key];
                            break;
                }
            }
        }
        const paramLanguage:string = '?language=' + this.model.selectedLanguage.code;
        if (this.isFlowCki) {
            const paramMarket:string = '&market=' + this.model.selectedMarket.code.toLowerCase();
            this.model.marketLabel = this.model.selectedMarket.description;
            this.$window.location.href =
                this.$window.location.origin + this.$window.location.pathname + paramLanguage + paramMarket + controlledURLPath + this.$window.location.hash;

        } else {
            this.$window.location.href = this.$window.location.origin + this.$window.location.pathname + paramLanguage + controlledURLPath;
        }
    };

    changeLanguageForMarketSelector = () => {
        const selectedMarketCode = this.model.selectedMarket.code.toLowerCase();
        this.model.languages = this.ibHeaderMainPageConstants.languagesWcs[selectedMarketCode];
        this.model.selectedLanguage = this.model.languages[0];
        this.model.marketLabel = this.model.selectedMarket.description;
    };

    afterLogin = () => {
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
        const CustomerInfo: CustomerDataCommons = this.localStorageService.get('customerData');
        const isIbZero = this.CommonsUserUtilsService.isIbZero();
        const isSoftUser = this.CommonsUserUtilsService.isSoftUser();
        const surname = isSoftUser ? '' : CustomerInfo.personalInfo.surname1;
        this.model.logged = true;
        this.model.customerData = {
            name: `${CustomerInfo.personalInfo.name || CustomerInfo.personalInfo.contactEmail} ${surname}`.trim(),
            avios: !isIbZero ? CustomerInfo.generalInfo.aviosTransformed : null
        };
        this.$rootScope.$emit('loginContinueEvent');
    };
    onLogin = () => {
        this.CommonsModalService.showWaitingModal('generic-wait-modal', 'ib-modals ib-modals--loading', true, null);
    };
    onError = (error: object) => {
        this.CommonsModalService.finishWaiting();
    };
    $onInit = () => {
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
        this.updateLoginModelEvent = this.$rootScope.$on('updateLoginModelEvent', this.updateLoginModel);
        this.$scope.$on('$destroy', this.updateLoginModelEvent);
        this.updateLoginModel();
        this.isSoftUser = this.CommonsUserUtilsService.isSoftUser();
        this.isFlowCki = this.$rootScope?.flowName === 'CKI';
    };
}
